export default [
	{
		name: 'root',
		label: 'Wrapper',
		selector: '&'
	},
	{
		name: 'author',
		label: 'Author',
		selector: '& .author'
  },
	{
		name: 'authorName',
		label: 'Author Name',
		selector: '& .author-name'
	},
	{
		name: 'authorLocation',
		label: 'Author Location',
		selector: '& .author-location'
  },
	{
		name: 'stars',
		label: 'Stars',
		selector: '& .stars'
	},
	{
		name: 'icon',
		label: 'Icon',
		selector: '& .c-icon'
	},
	{
		name: 'filledIcon',
		label: 'Filled Icon',
		selector: '& .icon-filled'
	},
	{
		name: 'emptyIcon',
		label: 'Empty Icon',
		selector: '& .icon-empty'
	},
	{
		name: 'reviewText',
		label: 'Review Text',
		selector: '& .review-text'
  }
]